import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './Button';
const STAR = 'https://cdn.magicpatterns.com/uploads/1zenjY5zFcqJGWhhbgWKub/cropped-cropped-AllStar-Star.png';
const POINTS = ['Fiber internet guidance for Vancouver, WA households', 'Address-based availability conversations', 'A simple, personal consultation process', 'Clear next steps for your home connection'];
export function About() {
  return <section id="about" className="w-full bg-background py-20 lg:py-28" data-id="element-9">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        x: -24
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-11">
          <div className="overflow-hidden rounded-3xl bg-brand p-10 sm:p-14" data-id="element-12">
            <img src={STAR} alt="" className="h-20 w-20 rounded-2xl" data-id="element-13" />
            <blockquote className="mt-8 font-heading text-2xl font-semibold leading-snug text-ink sm:text-3xl" data-id="element-14">
              “We believe fast internet should be available to all customers.”
            </blockquote>
            <p className="mt-6 text-sm font-medium uppercase tracking-wide text-ink/70" data-id="element-15">
              AllStar Home Solutions
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 24
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-16">
          <p className="text-sm font-semibold uppercase tracking-wide text-brand-dark" data-id="element-17">
            About AllStar
          </p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl" data-id="element-18">
            A local partner for your fiber search
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-muted-foreground" data-id="element-19">
            AllStar Home Solutions is a fiber internet dealer serving Vancouver,
            Washington. We help households begin with availability, understand
            their options, and move forward with confidence.
          </p>
          <ul className="mt-8 space-y-4" data-id="element-20">
            {POINTS.map(point => <li key={point} className="flex items-start gap-3" data-id="element-21">
                <span className="mt-0.5 inline-flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-brand/15 text-brand-dark" data-id="element-22">
                  <Check className="h-4 w-4" aria-hidden="true" data-id="element-23" />
                </span>
                <span className="text-foreground" data-id="element-24">{point}</span>
              </li>)}
          </ul>
          <Button asChild size="lg" className="mt-10 h-12 bg-brand px-7 text-base text-brand-foreground hover:bg-brand-dark" data-id="element-25">
            <a href="#contact" data-id="element-26">Check your address</a>
          </Button>
        </motion.div>
      </div>
    </section>;
}